<mat-card appearance="outlined" [formGroup]="formGroup" telemetry="Card-TotalCommunityConsumptionChart-UtilityBilling">
    <mat-card-header fxLayoutAlign="space-between center">
        <h2 class="forge-typography--heading4">Total Community Consumption</h2>
        <lgd-select fxFlex="40" controlName="serviceType" label="Service" [options]="serviceTypesObservable">
        </lgd-select>
        <forge-icon-button class="chart-settings" (click)="displayChartParameterDialogAndReload()" tabindex="0"
                           aria-haspopup="true" telemetry="Chart settings" aria-label="chart settings">
            <forge-tooltip>Chart settings</forge-tooltip>
            <forge-icon name="settings"></forge-icon>
        </forge-icon-button>
    </mat-card-header>

    <mat-card-content>
        <div *ngIf="isLoaded">
            <chartjs-container *ngIf="showChart" [config]="chartConfig">
            </chartjs-container>

            <div *ngIf="!chartHasData">
                Not enough data to display graph
            </div>
        </div>

        <busy-indicator *ngIf="!isLoaded" [chart]="true"></busy-indicator>
    </mat-card-content>
</mat-card>
